import React, { ReactNode } from "react";

import * as Styled from "./styles";

interface Props {
  type?: "submit" | "button" | "reset";
  disabled?: boolean;
  children?: ReactNode;
  action?(): void;
  color?: "green";
  isAvailable?: boolean;
}

const AddToCart: React.FC<Props> = props => {
  const {
    disabled = false,
    type = "button",
    children,
    action,
    color = "green",
    isAvailable = true,
  } = props;

  return (
    <Styled.Button
      disable={!isAvailable}
      type={type}
      color={color}
      onClick={disabled ? () => null : action}
      className="button-primary"
    >
      <Styled.CartIcon />
      <Styled.Label>{children}</Styled.Label>
    </Styled.Button>
  );
};

export default AddToCart;
